import styled from "styled-components";

export const CardWrapper = styled.div`
  width: 306px;
  height: 118px;
  padding: 12px;
  border-radius: 8px;
  display: flex;
  gap: 12px;
  justify-content: space-between;
  position: relative;
  background: ${({ background }) => (background ? background : "#fff")};
  box-shadow: 0px 4px 10px 0px #0000000a;

  & .info-wrapper {
    display: flex;
    flex-direction: column;
    /* justify-content: space-between; */
    gap: 14px;
    width: calc(100% - 99px);
    /* height: 36px;
    padding: 10px 16px;
    font-weight: 500;
    font-size: 15px;
    color: #343c6a; */
  }
  .dotsWrap {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    border: none;
    outline: none;
    background: none;
  }
  .slice-text {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  & .three-dots {
    cursor: pointer;
    color: #8490a5;
    font-size: 18px;
  }

  & .image-wrapper {
    width: 87px;
    height: 90px;
    border-radius: 10px 10px 10px 10px;
    overflow: hidden;
    /* position: relative; */

    .img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  & .member-name {
    width: 100%;
    /* margin-top: 12px; */
    color: #0c0a64;

    font-size: 16px;
    line-height: 16px;
    font-weight: 600;
    /* padding-left: 16px; */
    word-wrap: break-word;
  }

  & .member-position {
    font-weight: 500;
    font-size: 15px;
    line-height: 15px;
    width: 100%;
    /* margin-top: 12px;
    padding-left: 16px; */
    /* word-wrap: break-word; */
    color: #8490a5;
  }
`;

export const ThreeDotsContainer = styled.div`
  position: absolute;
  right: 0;
  top: 36px;
  z-index: 1;
  width: 100px;
  height: 50px;
  font-size: 13px;
  font-weight: 500;
  background-color: #fff;
  color: #343c6a;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  padding: 7px 10px;
  cursor: pointer;
  box-shadow: 0px 0px 10px #cececf;
`;

export const UpdateIcon = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  :hover {
    color: var(--sidebar-item-active);
  }
`;

export const DeleteIcon = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  :hover {
    color: red;
  }
`;
